/* eslint-disable max-len */

const dualPathTooltipCategories = {
  brio_inaisle_sfi_generalfs: [
    'Submit your contact information for a free pricing estimate and consultation',
    'Our expert installer will discuss the options available that best meet your needs and budget',
    'A licensed, local installer will schedule your installation and deliver the materials to your home',
    'Once the job is completed, we’ll clean up the area and request that you provide feedback on how we did'
  ],
  // tankless water heater
  brio_inaisle_sfi_twht: [
    'Submit your contact information for a free pricing estimate and consultation',
    'Your service provider will call to discuss your current setup and the best options for your needs and budget.They will also set up a free in-home consultation.',
    'During your consultation, our local, licensed installer will assess your current setup to see if a tankless water heater will fit your space and provide you with a project quote.',
    'When you’re ready to move forward, the installer will order the materials and schedule an installation and delivery date that’s convenient for you.',
    'Once the install is complete, the installer will fill and test your new water heater, clean up the job site, and haul away your old water heater.'
  ],
  // water heater
  brio_inaisle_sfi_whtr: [
    'Submit your contact information for a free pricing estimate and consultation',
    'Your service provider will call to discuss your current setup and the best options for your needs and budget. They will also set up a free in-home consultation.',
    'During your consultation, our local, licensed installer will survey the existing setup to ensure everything is up to code and will provide you with a project quote.',
    'When you’re ready to move forward, the installer will order the materials and schedule an installation and delivery date that’s convenient for you.',
    'Once the install is complete, the installer will fill and test your new water heater, clean up the job site, and haul away your old water heater.'
  ],
  // fencing
  BRIO_INAISLE_SFI_FENC: [
    'Submit your contact information for a free pricing estimate and consultation',
    'Our local fencing installer will call to discuss your fencing needs and set up a free in-home consultation.',
    'During your free consultation, a licensed, local installer will measure your yard, review style options, and provide a project quote.',
    'When you’re ready to move forward, we’ll order the materials and schedule an installation and delivery date that’s convenient for you.',
    'After the installation is complete, the installer will haul away debris and clean the job site. They will also conduct a final inspection and review product and service warranties.'
  ],
  // generator
  dualpath_inaisle_sfi_generators: [
    'Submit your contact information for a free pricing estimate and consultation',
    'Our expert installer will discuss the options available that best meet your needs and budget and schedule your free in-home consultation.',
    'During your consultation, a licensed, local installer will review your home’s energy needs, make product recommendations, and review pricing and financing options.',
    'When you’re ready to move forward, the installer will order the material\'s and schedule an installation and delivery date that’s convenient for you.',
    'After the installation, the installer will clean the job site, make a final inspection, and review your product and service warranties.'
  ],
  dualpath_inaisle_sfi_windows: [
    'Submit your contact information for a free pricing estimate and consultation',
    'A Home Depot specialist will call to discuss your current setup and the best options for your needs and budget. They will also set up a free in-home consultation.',
    'During your consultation, we will help you choose the best windows for your needs, take professional measurements, and provide you with a project quote.',
    'When you’re ready to move forward, we will schedule your installation and material delivery date.',
    'After the installation is complete, we will haul away your old windows and clean up the job site.',
    'Your new windows will come with a lifetime warranty on labor and accidental glass breakage and up to double-lifetime warranty on window hardware and screens.'
  ],
};

const getDualPathCategoryModel = (category) => {
  if (dualPathTooltipCategories[category]) {
    return dualPathTooltipCategories[category];
  }
  return dualPathTooltipCategories.brio_inaisle_sfi_generalfs;
};

export { getDualPathCategoryModel };